import { ICheckinParams, PropertiesAPI } from "../../services/hcnApi";

export const checkinUseCase = async (params: ICheckinParams) => {
  return await PropertiesAPI.checkin(params);
};
